import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ConditionEditorContext, ConditionEditorContextConsumer, ConditionEntry } from '@sdbn/common-extended';
import { Subject } from 'rxjs';

@Component({
  selector: 'yard-string-1-condition-editor',
  standalone: false,
  templateUrl: './string-1-condition-editor.component.html',
  styleUrl: './string-1-condition-editor.component.scss',
})
export class String1ConditionEditorComponent implements OnInit,  ConditionEditorContextConsumer {

  condition: ConditionEntry;

  formGroup = new FormGroup({
    value: new FormControl(null, [])
  });

  setConditionEditorContext(context: ConditionEditorContext): void {
    context.selectedCondition.subscribe(
      condition => {
        this.condition = condition;
        this.formGroup.patchValue({ value: condition.data });
      }
    );
  }

  setChangedSubject(changed: Subject<void>): void {
  }

  ngOnInit(): void {
    this.formGroup.valueChanges.subscribe(value => {
      this.condition.data = value.value;
    });
  }

}
